// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LikeTwoToneSvg from "@fishx/icons-svg/es/asn/LikeTwoTone";
import FishxIcon from '../components/FishxIcon';

var LikeTwoTone = function LikeTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LikeTwoToneSvg
  }));
};

LikeTwoTone.displayName = 'LikeTwoTone';
export default React.forwardRef(LikeTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LikeTwoTone.js
// module id = 3037
// module chunks = 0